<script>
import axios from 'axios';
import {isArray} from "lodash";
export default {

    data() {
        return {
            invitee: {
                first_name: '',
                last_name: '',
                email: '',
                role: null
            },
            messageType: null,
            message: '',
        }
    },

    methods: {
        async inviteUser() {
            try {

                const response = await axios.post('/api/team/invitations', this.invitee);
                console.log(response);

            }catch(err){

                if(err.toString() === 'Error: Request failed with status code 422') {
                    let errorMessage = '<p>There was an error validating your submission:</p>';
                    // build error message list
                    if(typeof err.response.data.errors === 'object') {
                        errorMessage += '<ul>';
                        for (var key in err.response.data.errors) {
                            if (isArray(err.response.data.errors[key]) && err.response.data.errors.hasOwnProperty(key)) {
                                errorMessage += '<li>';
                                err.response.data.errors[key].forEach(message => {
                                    errorMessage += message;
                                })
                                errorMessage += '</li>';
                            } else {
                                errorMessage += '<li>' + err.response.data.errors[key] + '</li>';
                            }
                        }
                        errorMessage += '</ul>';
                    }

                    this.message = errorMessage;
                } else {
                    this.message = 'An unknown error occurred while trying to invite the user.';
                }
                this.messageType = 'error'
            }

        }
    },

    props: {
        possibleRoles: {
            required: true,
            type: Array
        }
    }
}
</script>
<template>
    <div>

        <form @submit.prevent="inviteUser">
            <p class="w-3/4 mx-4" :class="{ 'text-green': messageType === 'success', 'text-red': messageType === 'error'}" v-if="message" v-html="message"></p>
            <div class="flex justify-center items-center">
                <form-text
                    class="w-1/5 mx-2"
                    field-name="invitee-first-name"
                    label="First name"
                    v-model="invitee.first_name"
                    :required="true"
                ></form-text>
                <form-text
                    class="w-1/5 mx-2"
                    field-name="invitee-last-name"
                    label="Last Name"
                    v-model="invitee.last_name"
                    :required="true"
                ></form-text>
                <form-text
                    class="w-1/4 mx-2"
                    field-name="invitee-last-name"
                    label="Email"
                    v-model="invitee.email"
                    :required="true"
                ></form-text>

                <form-radio
                    class="w-1/4 mx-2"
                    field-name="role"
                    label="Role"
                    v-model="invitee.role"
                    option-label-field="title"
                    option-value-field="name"
                    :options="possibleRoles"
                    :required="true"
                ></form-radio>
            </div>
            <div class="flex justify-center">
                <button class="inputbutton1 rounded w-1/4">
                    Invite
                </button>
            </div>

        </form>
        <h3 class="mt-4">Current team members</h3>
        <v-grid
            :headers="['First name', 'Last name', 'Email/Username', '']"
            record-url="/api/team"
            :allow-refresh="true"
            :grid-args="{ noRecordsText: 'No team members' }"
            :use-json-api="true"
            record-type="team-member-row"
        ></v-grid>

        <h3 class="mt-4">Team member invitations</h3>
        <v-grid
            :headers="['First name', 'Last name', 'Email/Username', '']"
            record-url="/api/team/invitations"
            :allow-refresh="true"
            :grid-args="{ noRecordsText: 'No Invitations' }"
            :use-json-api="true"
            record-type="team-member-invitation-row"
        ></v-grid>

    </div>
</template>
<style>
input[type=text] {
    border: 1px solid; padding: 10px;
}
.w-1\/5 {
    width: 20%;
}
</style>
